import vueInstance from "../main";

export const delegationOrderStatus = Object.freeze({
  STATUS_DELETED: 0,
  STATUS_CREATED: 1,
  STATUS_SUBMITTED: 2,
  STATUS_ACCEPTED: 3,
  STATUS_REJECTED: 4,
  STATUS_REJECTED_FOR_CORRECT: 5,
  STATUS_CANCELLED: 6
});

export const delegationOrderStatusExtended = function() {
  return [
    //{text: vueInstance.$t('delegationOrder.statusText.deleted'), value: delegationOrderStatus.STATUS_DELETED},
    {
      text: vueInstance.$t("delegationOrder.statusText.created"),
      value: delegationOrderStatus.STATUS_CREATED,
      color: "grey",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegationOrder.statusText.submitted"),
      value: delegationOrderStatus.STATUS_SUBMITTED,
      color: "primary",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegationOrder.statusText.accepted"),
      value: delegationOrderStatus.STATUS_ACCEPTED,
      color: "success",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegationOrder.statusText.rejected"),
      value: delegationOrderStatus.STATUS_REJECTED,
      color: "red",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegationOrder.statusText.rejectedForCorrect"),
      value: delegationOrderStatus.STATUS_REJECTED_FOR_CORRECT,
      color: "red",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegationOrder.statusText.cancelled"),
      value: delegationOrderStatus.STATUS_CANCELLED,
      color: "warning",
      textColor: "white"
    }
  ];
};
